function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsageFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 119 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.606,
    height: 15.743,
    viewBox: "0 0 15.606 15.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5465",
    d: "M4.6 12.261A6 6 0 0 1 .5 6.392C.5 3.228 2.936.5 5.772.5h5.2c2.836 0 5.136 2.711 5.136 5.874 0 3.132-2.3 5.874-5.136 5.874H9.333L4.6 16.243z",
    transform: "translate(-.5 -.5)",
    style: {
      fill: "#fcaf17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5504",
    d: "m5.49 9.85 2.11 2.172 4.547-4.676",
    transform: "translate(-1.017 -3.15)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageFlag);
export default __webpack_public_path__ + "static/media/usageFlag.27d357f118a8251011d6618f101dfa64.svg";
export { ForwardRef as ReactComponent };